import React from "react"
import { MDXRenderer } from "gatsby-plugin-mdx"

const PostContent = ({ post }) => (
  <article className="body">
    <div className="section w-full font-sans font-thin leading-normal rte">
      <MDXRenderer>{post.body}</MDXRenderer>
    </div>
  </article>
)

export default PostContent
